/* eslint-disable jsx-a11y/alt-text */
import $ST from "plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail";
import $R from "plugins/tfs/platformConfigs/integrationMaps/routes";
import $U from "plugins/tfs/platformConfigs/integrationMaps/urls";
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Button, Popover, Divider } from "antd";
import {
  parameterizedString,
  thumbnailImageUrl,
  dateFormatter,
  copyClipboard,
  hasAnyKey,
} from "theme/utils";
import IndexBox from "components/ui-ant/IndexBox";
import { DatatableBox } from "components/ui-ant/Datatable";
import DetailList from "components/ui-ant/DetailList";
import Image from "theme/Image";
import "../main/style.css";
import PrintableArea from "components/partials/PrintableArea";
import PrintableView from "../printableView";
import $S from "theme/settings";
import giftGif from "./gift.gif";

class DesktopView extends Component {
  state = {
    selectedRows: [],
    miscModalVisible: false,
  };

  columns = () => {
    const {
      packageOrder: {
        stockLocation: { name: stockLocationName },
        transferDestination,
        transferTargetDate,
        state: { name: stateName },
      },
      onOpenImageModal,
    } = this.props;
    const {
      packageOrderDetailModalImageHeight: height,
      packageOrderDetailModalImageWidth: width,
    } = $S;

    return [
      {
        dataIndex: "orderItem.product.image",
        title: $ST.TABLE.COL.IMAGE,
        render: (image) => {
          return (
            <Image
              src={thumbnailImageUrl(image, 50, 50)}
              width={50}
              height={50}
              onClick={() => {
                onOpenImageModal(thumbnailImageUrl(image, width, height));
              }}
            />
          );
        },
      },
      {
        dataIndex: "orderItem.product.sku",
        title: $ST.TABLE.COL.SKU,
      },
      {
        dataIndex: "orderItem.product.name",
        title: $ST.TABLE.COL.NAME,
        render: (cellData, rowData) =>
          this.renderNameWithGiftNote(cellData, rowData),
      },
      {
        dataIndex: "orderItem.product.baseName",
        title: $ST.TABLE.COL.BASE_NAME,
      },
      {
        dataIndex: "orderItem.product.color",
        title: $ST.TABLE.COL.COLOR,
      },
      {
        dataIndex: "orderItem.product.size",
        title: $ST.TABLE.COL.SIZE,
      },
      {
        dataIndex: "orderItem.product.attributes.integration_sizeYdescription",
        title: $ST.TABLE.COL.LENGTH,
      },
      {
        dataIndex: "",
        title: $ST.TABLE.COL.SOURCE_NAME,
        render: () => stockLocationName,
      },
      {
        dataIndex: "",
        title: $ST.TABLE.COL.DESTINATION_NAME,
        render: () => transferDestination,
      },
      {
        dataIndex: "",
        title: $ST.TABLE.COL.TRANSFER_DATE,
        render: () => transferTargetDate && dateFormatter(transferTargetDate),
      },
      {
        dataIndex: "",
        title: $ST.TABLE.COL.STATUS,
        render: () => stateName,
      },
    ].map((data, index) => ({ key: index + 1, ...data }));
  };

  createDetailList = () => {
    const {
      packageOrder: {
        id,
        idEncrypted,
        orderId,
        orderNumber,
        number,
        channelName,
        stockLocation: {
          stockLocationName,
          addressTitle,
          addressLine,
          addressCity,
        },
        state: { name: stateName },
        shipment,
        shipmentCargoName,
        shipmentAwbNumber,
        shippingLabel,
        shippingPreviewUrl,
        shippingAddress: {
          customerName,
          customerSurname,
          customerEmail,
          phone,
          title,
          line,
          city,
          township,
          district,
          country,
        },
        giftBoxNote,
        isClickAndCollect,
      },
    } = this.props;

    const detailObject = {
      title: number,
      detailList: [
        {
          title: $ST.PACKAGE_INFO,
          listItems: [
            {
              title: $ST.PACKAGE_NUMBER,
              description: number,
            },
            {
              title: $ST.STOCK_LOCATION_ADDRESS,
              description: `${addressTitle} ${addressLine
                .split($ST.SEPERATOR)
                .join(" ")} ${addressCity}`,
            },
            {
              title: $ST.STOCK_LOCATION,
              description: stockLocationName,
            },
            {
              title: $ST.PACKAGE_STATUS,
              description: stateName,
            },
            {
              title: shipment && $ST.CARGO_COMPANY,
              description: shipmentCargoName,
            },
            {
              title: shipment && $ST.AWB_NUMBER,
              description: shipmentAwbNumber,
            },
            {
              title: $ST.PACKAGE_TYPE,
              description: isClickAndCollect ? $ST.CLICK_AND_COLLECT : "-",
            },
            {
              title: "",
              description: shippingLabel && $ST.PREVIEW_SHIPPING_LABEL,
              type: "blankLink",
              target: "_blank",
              eventParams: shippingPreviewUrl,
            },
            {
              title: "",
              description:
                (shipment || isClickAndCollect) && $ST.PREVIEW_PACKAGE_DOCUMENT,
              type: "blankLink",
              target: "_blank",
              eventParams: `/api/v1/oms/packages/${idEncrypted}/?format=html`,
            },
          ],
        },
        {
          title: $ST.ORDER_INFO,
          listItems: [
            {
              title: $ST.ORDER_NUMBER,
              description: orderNumber,
              eventType: "navigate",
              eventParams: `/oms/orders/order-detail/${orderId}`,
            },
            {
              title: $ST.FULL_NAME,
              description: `${customerName} ${customerSurname}`,
            },
            {
              title: $ST.EMAIL,
              description: customerEmail,
            },
            {
              title: $ST.PHONE,
              description: phone,
            },
            {
              title: $ST.CHANNEL,
              description: channelName,
            },
            {
              title: giftBoxNote && $ST.GIFT_BOX_NOTE,
              description: giftBoxNote,
              color: "#FF5722",
            },
          ],
        },
        {
          title: $ST.ADDRESS_DETAILS,
          listItems: [
            {
              title: $ST.SHIPPING_ADDRESS,
              description: (
                <div
                  style={{
                    display: "grid",
                    gap: "3px",
                  }}
                >
                  <p>
                    <b>{title}</b>
                  </p>
                  <p>{district}</p>
                  <p>{line.split($ST.SEPERATOR).join($ST.CONCATENATOR)}</p>
                  <p>{city}</p>
                  <p>{township}</p>
                  <p>{country}</p>
                </div>
              ),
            },
          ],
        },
      ],
    };

    return id
      ? detailObject
      : {
          title: "",
          detailList: [],
        };
  };

  rowSelection = {
    onRowSelection: (selectedRowKeys, selectedRows) => {
      this.setState({
        selectedRows,
      });
    },
  };

  getSelectedIds = () => {
    const { selectedRows } = this.state;
    return selectedRows.map(({ id }) => id);
  };

  printNoteStyle = {
    padding: "40px",
    width: "40%",
    marginLeft: "auto",
    boxShadow: "inset -7px -5px 25px 1px rgba(0,0,0,0.2);",
  };

  renderNameWithGiftNote = (productName, rowData) => {
    const { onOpenMiscModal, packageOrder } = this.props;
    const { orderHasGiftBox, giftBoxNote } = packageOrder;
    const {
      orderItem: { attributesKwargs },
    } = rowData;
    let _giftNote = giftBoxNote != null ? giftBoxNote : "-";
    const popoverContent = (
      <div className="gift-note-popover">
        <div>
          <strong>{$ST.GIFT_NOTE}</strong>
          <Divider className="mv10" />
        </div>
        <p>{_giftNote}</p>
        <div className="flex-end">
          <Button
            onClick={() => {
              copyClipboard(_giftNote);
            }}
            className="mr8"
          >
            {$ST.COPY}
          </Button>
          <PrintableArea
            renderButton
            trigger={
              <Button className="print-button center mb15">{$ST.PRINT}</Button>
            }
          >
            <div className="print-note" style={this.printNoteStyle}>
              <p>{_giftNote}</p>
            </div>
          </PrintableArea>
        </div>
      </div>
    );
    return (
      <Fragment>
        <span className="mr8">{productName}</span>
        {hasAnyKey(attributesKwargs) && (
          <Button
            className="mr8"
            onClick={() => onOpenMiscModal(rowData)}
            type="primary"
            shape="circle"
            icon="info"
            size="default"
          />
        )}
        {orderHasGiftBox && (
          <Popover placement="top" content={popoverContent} trigger="click">
            <img
              className="gift-img"
              src={giftGif}
              style={{ cursor: "pointer" }}
            />
          </Popover>
        )}
      </Fragment>
    );
  };

  render() {
    const {
      packageOrder: { id, number, packageItemSet } = {},
      packageOrder,
      packages,
      onActionClick,
      actionButtons = [],
    } = this.props;
    const { detailList, title: detailTitle } = this.createDetailList();

    const getFiltersURL = $U.FILTERS_URL;
    return (
      <div className="container-fluid headerMargin oms">
        <div className="fs25">
          <Link className="breadcrumb-item" to={$R.PACKAGE_ORDER_LIST.path}>
            {$ST.PACKAGE_ORDERS}
          </Link>
          {` > ${$ST.PACKAGE_DETAIL}`}
        </div>
        {id && packages && (
          <DetailList detailList={detailList} title={detailTitle} />
        )}
        {packageItemSet && (
          <Fragment>
            {$S.isPackageOrderDetailPrintable && (
              <PrintableArea
                trigger={
                  <Button className="print-button center mb15">
                    {$ST.PRINT}
                  </Button>
                }
              >
                <PrintableView {...{ packageOrder }} />
              </PrintableArea>
            )}
            <IndexBox
              title={parameterizedString($ST.PACKAGE_INFO_WITH_NUMBER, number)}
            >
              <DatatableBox
                actionButtons={actionButtons}
                onActionClick={onActionClick.bind(this, this.getSelectedIds())}
                draggable={false}
                pagination={false}
                columns={this.columns()}
                rowKey="id"
                filterKey="orderItem"
                dataSource={packageItemSet}
                rowSelection={this.rowSelection}
                filtersURL={getFiltersURL}
              />
            </IndexBox>
          </Fragment>
        )}
      </div>
    );
  }
}

export default DesktopView;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/desktopView/index.js